import '../CateogaryWise/cateogary.css'
// import data from '../FakeData/recentBlogPosts.json'
import data from '../FakeData/index.json'
import React from 'react'
import CateogaryPost from '../CateogaryWise/CateogaryPost'
import UseFetch from '../UseFetch'
import mainData from '../FetchDataLinks'
import CateogaryPostSkeleton from '../CateogaryWise/CateogaryPostSkeleton'

function RecentPosts() {

    let a = 0;

    const { blogs, loading } = UseFetch(`${mainData.recentBlogs}`)

    let head = 'Recent Blog Posts'
    return (
        <div className="w3l-homeblock2 py-5">
            <div className="container py-lg-5 py-md-4">
                <div className="left-right">
                    <h3 className="section-title-left mb-sm-4 mb-2"> {head} </h3>
                    <a href={`/blogs`} style={{ background: `#5a67d8` }} className="more btn btn-small mb-sm-0 mb-4">View more</a>
                </div>
                <div className="row">
                    {loading && Array(3).fill().map(() => {
                        a++;
                        return <CateogaryPostSkeleton key={`CateogarySkeleton${a}`} />
                    })}
                    {!loading && blogs.map((blog) => {
                        return <CateogaryPost key={blog.id} image={blog.Image} slug={blog.slug} PostHead={blog.Headline} authorName={data[0].authorName} date={blog.date} time={blog.Time} />
                    })}
                </div>
            </div>
        </div>
    )
}

export default RecentPosts

